/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import {
  Button,
  ButtonGroup,
  Link,
  Modal,
  ModalContent,
  Text,
} from '@zapier/design-system';

const Styles = {
  root: css`
    display: grid;
    grid-gap: 20px;
    text-align: center;
  `,
};

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

const AutoUpgradeWarningModal = ({ onClose, onConfirm }: Props) => {
  return (
    <Modal onClosed={onClose}>
      <ModalContent>
        <div css={Styles.root}>
          <Text type="paragraph1Bold">
            Automatic task upgrade will be disabled
          </Text>
          <Text type="paragraph3">
            Heads up, switching to yearly billing will disable{' '}
            <Link href="/l/automatic-task-upgrades">
              automatic task upgrade
            </Link>{' '}
            as we don’t yet support annual billing in the beta.
          </Text>
          <Text type="paragraph3">
            If you run out of tasks, your Zaps will pause until the following
            month or you upgrade your plan.{' '}
            <Text type="paragraph3Bold">Are you sure?</Text>
          </Text>
          <ButtonGroup>
            <Button color="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button color="primary" onClick={onConfirm}>
              Switch to annual billing
            </Button>
          </ButtonGroup>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default AutoUpgradeWarningModal;
